import { ID } from '../../types/id'
export const initialValuesSingle = {
  type: 'SINGLE',
  answerOptions: [
    {
      answer: 'Tak',
    },
    {
      answer: 'Nie',
    },
  ],
}
export const initialValuesMultiple = {
  type: 'MULTIPLE',
  answerOptions: [
    {
      answer: 'Tak',
    },
    {
      answer: 'Nie',
    },
    {
      answer: 'Inna',
    },
  ],
}
export const initialValuesLikert = {
  type: 'LIKERT',
  answerOptions: [
    {
      answer: 'Zdecydowanie tak',
    },
    {
      answer: 'Chyba tak',
    },
    {
      answer: 'Nie wiem',
    },
    {
      answer: 'Chyba nie',
    },
    {
      answer: 'Zdecydowanie nie',
    },
  ],
}
export const initialValuesShort = {
  type: 'SHORT',
  answerOptions: [],
}
export const initialValuesLong = {
  type: 'LONG',
  answerOptions: [],
}
export const initialValuesImage = {
  type: 'IMAGE',
  answerOptions: [
    {
      answer: 'Obrazek 1',
      fileId: null,
    },
    {
      answer: 'Obrazek 2',
      fileId: null,
    },
  ],
}

export const questionType = [
  {
    value: 'SINGLE',
    label: 'Jednokrotny wybór',
    description: 'Wybierz jedną odpowiedź',
    initialValue: initialValuesSingle,
  },
  {
    value: 'MULTIPLE',
    label: 'Wielokrotny wybór',
    description: 'Wybierz wiele odpowiedzi',
    initialValue: initialValuesMultiple,
  },
  {
    value: 'LIKERT',
    label: 'Skala Likerta',
    description: 'Wybierz jedną odpowiedź',
    initialValue: initialValuesLikert,
  },
  {
    value: 'SHORT',
    label: 'Krótka odpowiedź',
    description: 'Podaj krótką odpowiedź',
    initialValue: initialValuesShort,
  },
  {
    value: 'LONG',
    label: 'Długa odpowiedź',
    description: 'Podaj długą odpowiedź',
    initialValue: initialValuesLong,
  },
  {
    value: 'IMAGE',
    label: 'Wybór obrazka',
    description: 'Wybierz jedną odpowiedź',
    initialValue: initialValuesImage,
  },
]

export type ActiveQuestion = {
  type: string
  question?: string | null
  answerOptions?: Array<any> | null
  id?: ID | null
  answers?: Array<string>
}

export type ActiveQuestionHeader = {
  title: string
  description: string
}

export type User = {
  unitId: ID
  userId: ID
  userLevel: number
}
export type Users = {
  creationDate: string
  emailAddress: string
  firstName: string
  id: number
  lastName: string
  login: string
  roles: any[]
  unitId: number
}

export type AnsweredSurvey = {
  title: string
  description: string
  answeredCount: number
  sentCount: number
}

type Answers = {
  questionId: number
  answerOptionIds: Array<{
    answer: ID
    fileId: ID
  }>
  shortAnswer: string
  longAnswer: string
}
export type SurveyAnswers = {
  answers: Array<Answers>
}

export type ListedSurvey = {
  id: ID
  title: string
  description: string
  userId: ID
  creationDate: Date
  editable: boolean
  surveySentCount: number
  surveyAnsweredCount: number
}
